import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux";
import { fetchModalities } from "../../../redux/resources/resourcesSlice";
import { useCallback } from "react";
import { useDispatch } from "react-redux";


interface Modality {
    _id: string;
    name: string;
    description?: string;
}

const transforModalities = (modalities: Modality[]) => {
    return modalities.map(modality => ({
        ...modality,
        id: modality._id
    }))
}

const useFetchModalityResource = () => {
    const dispatch = useDispatch<AppDispatch>();

    const modalities = useSelector((state: RootState) => state.resources?.modalities);
    const loading    = useSelector((state: RootState) => state.resources?.isLoading);
    
    useEffect(() => {
        dispatch(fetchModalities());
    }, [dispatch])

    return {
        modalities: transforModalities(modalities),
        loading
    }
}

export default useFetchModalityResource;